<ion-button
  shape="round"
  [fill]="fill"
  [color]="color"
  [size]="size === 'sm' ? 'small' : 'default'"
  [type]="type"
  [disabled]="disabled || loading"
  [attr.disabled]="reflectDisabledAttribute && (disabled || loading) ? '' : null"
  [class.app-button--soft]="variant === 'soft'"
  [class.app-button--block]="block"
  [class.app-button--neutral-outline]="neutralOutline"
  [class.app-button--success]="variant === 'success'"
  [class.app-button--success-emphasis]="successEmphasis"
  [class.app-button--disabled-neutral]="disabledTone === 'neutral' && (disabled || loading)"
  [attr.aria-label]="ariaLabel || null"
  [attr.aria-disabled]="exposeDisabledState ? (disabled || loading) : null"
  [attr.aria-busy]="loading"
  (click)="onClick($event)">
  <ion-spinner *ngIf="loading" slot="start" name="crescent" aria-hidden="true"></ion-spinner>
  <ion-icon *ngIf="iconLeft && !loading" slot="start" [name]="iconLeft" aria-hidden="true"></ion-icon>
  <ng-content></ng-content>
  <ion-icon *ngIf="iconRight" slot="end" [name]="iconRight" aria-hidden="true"></ion-icon>
</ion-button>